/**
 * TanStack Query hooks for `platform-fee-bank`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	platformFeeBankQueryKeys,
	type CreatePlatformFeeBankBody,
	type ListPlatformFeeBankResponse,
	type PlatformFeeBankRow,
} from "./api";

export function usePlatformFeeBankList(): UseQueryResult<ListPlatformFeeBankResponse, Error> {
	return useQuery({
		queryKey: platformFeeBankQueryKeys.list(),
		queryFn: list,
	});
}

export function usePlatformFeeBankCreate(): UseMutationResult<PlatformFeeBankRow, Error, CreatePlatformFeeBankBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: platformFeeBankQueryKeys.all });
		},
	});
}

export function usePlatformFeeBankDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: platformFeeBankQueryKeys.all });
		},
	});
}
